module.exports = __webpack_public_path__ + "img/village-sample.9b276a67.jpg";